<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'home' }">{{
                $t("inicio")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'configuracion-carta' }">{{
                $t("configuracionCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'categorias-carta' }">{{
                $t("categoriasCarta")
              }}</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              {{ action }} {{ $t("categoriaCarta") }}
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-md-12">
        <div class="card">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group needs-validation">
                <label for="nombreCategoria"
                  ><strong>{{ $t("nombre") }}</strong>
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="nombreCategoria"
                  v-model="categoria.nombre"
                  maxlength="127"
                />
                <em>
                  <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, categoria.nombre.length) }}</span>
                </em>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="descripcionCategoria">
                  <strong>{{ $t("descripcion") }}</strong>
                </label>
                <input
                id="descripcionCategoria"
                v-model="categoria.descripcion"
                class="form-control"
                maxlength="127"
                />
                <em>
                  <span style="font-size: 12px !important;" class="col-md-3">{{ $t("caracteresRestantes") }}: {{ calculateNumberOfCharacters(127, categoria.descripcion.length) }}</span>
                </em>
              </div>
            </div>

            <div class="col-md-2" v-tooltip.right="$t('tolTipOrdenCategorias')">
              <div class="form-group">
                <label for="ordenCategoria"
                  ><strong>{{ $t("orden") }}</strong></label
                >
                <input
                  type="number"
                  min="0"
                  id="ordenCategoria"
                  v-model="categoria.orden"
                  class="form-control"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>
                  <strong>{{ $t("baja") }}</strong>
                </label>
                <el-switch
                  v-tooltip.right="$t('tolTipBajaCategoria')"
                  v-model="categoria.baja"
                  active-color="#13ce66"
                  inactive-color="#bcbcbc"
                >
                </el-switch>
              </div>
            </div>

            <div class="col-md-12">
              <button class="btn btn-primary" @click="saveCategoria()">
                <i class="fa fa-check-square"></i> {{ $t("guardar") }}
              </button>
              <router-link :to="{ name: 'categorias-carta' }">
                <button class="btn btn-danger">
                  <i class="fa fa-window-close"></i> {{ $t("cancelar") }}
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button,
  Switch,
} from "element-ui";
import { Loading } from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
export default {
  name: "CategoriaCarta",
  components: {
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Switch.name]: Switch,
  },
  data() {
    return {
      idCategoria: this.$route.params.idCategoria,
      idBusiness: this.$route.params.idBusiness,
      action: "",

      categoria: {
        nombre: "",
        descripcion: "",
        orden: 999,
      },
    };
  },
  created() {
    this.action = this.idCategoria
      ? this.$i18n.t("editar")
      : this.$i18n.t("nuevo");

    if (this.idCategoria) {
      this.getCategoriaCarta();
    }
  },
  methods: {
    getCategoriaCarta() {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idCategoria: this.idCategoria,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.$store.dispatch("setIdBusiness", this.idBusiness);
      this.axios
        .get(
          this.$store.getters.apiUrl + "delivery/getCategoriaCartaById",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.categoria = response.data.result;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    saveCategoria() {
      if (this.checkCategoria()) {
        var config = {
          params: {
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };
        var params = {
          idBusiness: this.idBusiness,
          categoria: this.categoria,
          jwt: this.$store.getters.jwt,
        };

        let vm = this;
        let controller = this.idCategoria
          ? "editarCategoriaCarta"
          : "saveCategoriaCarta";
        this.axios
          .post(
            this.$store.getters.apiUrl + "delivery/" + controller,
            params,
            config
          )
          .then(function(response) {
            if (response.data.response) {
              vm.$router.push({
                name: "categorias-carta",
                params: { idBusiness: vm.idBusiness },
              });

              let notify = vm.$t("editada");
              vm.$notify({
                message:
                  vm.$t("categoria") +
                  " " +
                  notify +
                  " " +
                  vm.$t("correctamente"),
                icon: "nc-icon nc-check-2",
                timeout: 2000,
                horizontalAlign: "right",
                verticalAlign: "top",
                type: "success",
              });
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.log(error);
            vm.inProgress = false;
          });
      }
    },
    checkCategoria() {
      var check = true;

      if (this.categoria.nombre === "") {
        swal({
          title: this.$t("atencion"),
          text: this.$t("relleneLosCamposObligatorios"),
          confirmButtonClass: "btn btn-info btn-fill",
          type: "error",
        });

        check = false;
      }

      return check;
    },
    calculateNumberOfCharacters(total, variableLength) {
      return total - variableLength;
    },
  },
};
</script>

<style scoped>
.card {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Delivery/Configuracion/Categorias/CategoriaCarta.vue